import React from 'react';
import ThemedText from '../theme/ThemedText';
import './Badge.scss';

const Badge = ({ text, bgColor, color }) => {
  const style = {
    borderColor: color,
    backgroundColor: bgColor,
    color: color,
  };
  return (
    <ThemedText.h6 className='badge_wrapper' style={style}>
      {text}
    </ThemedText.h6>
  );
};

export const GreenBadge = ({ text }) => {
  return <Badge text={text} bgColor={'#EBFFE0'} color={'#159C4A'} />;
};

export const RedBadge = ({ text }) => {
  return <Badge text={text} bgColor={'#FFE8E8'} color={'#C72929'} />;
};

export const BlueBadge = ({ text }) => {
  return <Badge text={text} bgColor={'#E7EAFF'} color={'#314DDF'} />;
};

export default Badge;
